import React from 'react'
import About from '../public/about/About'
import MenuAdmin from './navAdmin/Menu'

function AboutAdmin() {
    return (
        <div>
            <MenuAdmin menuActive={'managewebsite'}/>
            <About disabledMenu={"admin"} role={"admin"}/>
        </div>
    )
}

export default AboutAdmin